import { McsisPolicy } from '@/models/constants/McsisPolicy';
import LocalStoreService from '@/store/local.store';


/**
 * Manage how the policies are being stored and retrieved from storage.
 *
 * Current implementation stores to localStorage (LocalStoreService).
 */
export default class AuthService {
  public static readonly POLICIES = 'policies';

  /**
   * Get the policies
   * @returns {Map<McsisPolicy, string[]>} The policies
   */
  public static getPolicies(): Map<McsisPolicy, string[]> {
    const policies = LocalStoreService.getItem(this.POLICIES);
    return JSON.parse(policies as string);
  }

  /**
   * Save the given policies
   * @param policies The policies
   */
  public static savePolicies(policies: Map<McsisPolicy, string[]>) {
    LocalStoreService.setItem(this.POLICIES, JSON.stringify(policies));
  }

  /**
   * Remove/delete the policies
   */
  public static removePolicies() {
    LocalStoreService.deleteItem(this.POLICIES);
  }

}
